var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-container"}},[(_vm.not_found)?[_c('NotFound')]:_vm._e(),(!_vm.not_found)?_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
var route = ref.route;
return [_c('keep-alive',{attrs:{"max":"10"}},[_c(Component,{key:route.meta.usePathKey ? route.path : undefined,tag:"component",attrs:{"view-prop":"value"}})],1)]}}],null,false,738404774)}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }